import store from '@/state/store'

import linkoutMenu from './routers/linkout'
import master from './routers/master'
import system from './routers/system'
import process from './routers/process'
import production from './routers/production'
import integration from './routers/integration'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      title: 'Dashboard',
      authRequired: true,
    },
    component: () => import('../views/main/index'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/account/login.vue'),
    meta: {
      title: 'Login',
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'default' })
          next()
        } else {
          next()
        }
      },
    },
  },
  ...linkoutMenu,
  ...master,
  ...system,
  ...process,
  ...production,
  ...integration
]
